<div #questionnaireContainer>
  <h2 class="pb-[2.5rem]">{{ 'questionnairePage.title' | transloco }}</h2>

  @if (store.isLoading()) {
  <div class="flex justify-center items-center min-h-[25rem]">
    <div class="text-vinciGrey-500">
      {{ 'questionnairePage.loadQuestionnaireText' | transloco }}
    </div>
  </div>
  } @if (!store.isLoading() && store.questionnaire() &&
  store.questionnaire()!.sections.length > 0) {
  <div class="flex flex-col gap-[2.5rem] mb-[8.75rem]">
    @for(section of store.questionnaire()!.sections; track $index) {
    @if(section.questions && section.questions.length > 0) {
    <questionnaire-section
      #questionnaireSection
      [title]="section.title"
      [section]="section"
      [sectionIndex]="$index"
    ></questionnaire-section>
    } } @if(isSaving()){ <loader class="self-end" /> } @else {
    <app-button
      [text]="'questionnairePage.submitButtonText' | transloco"
      [variant]="'secondary'"
      [icon]="'arrow-right'"
      (buttonClick)="submitQuestionnaire()"
      class="self-end"
    ></app-button
    >}
  </div>
  } @if (!store.isLoading() && (!store.questionnaire() ||
  store.questionnaire()!.sections.length === 0)) {
  <div class="flex justify-center items-center min-h-[25rem]">
    <div class="text-vinciGrey-500">
      {{ 'questionnairePage.noAvailableSection' | transloco }}
    </div>
  </div>
  }
</div>

@if(isMaturityModalOpen()){
<app-modal
  [title]="modalTitle() | transloco"
  [text]="modalText() | transloco"
  [buttonText]="modalButtonText() | transloco"
  (completeModal)="completeModal()"
  (closeModal)="closeModal()"
></app-modal>
}
